import getStyledLink from "./getStyledLink";
import { Link as GatsbyLink } from "gatsby";

const Link = getStyledLink(GatsbyLink);

export { Link };
